/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

import React from 'react';
var RendererContext = /*#__PURE__*/React.createContext({});
export var useRendererContext = function useRendererContext() {
  return React.useContext(RendererContext);
};
export var RendererContextProvider = RendererContext.Provider;